<script setup lang="ts">
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import LinkQC from '@qicgroupdoha/qic-connect-ds/components/LinkQC'
  import ModalQC from '@qicgroupdoha/qic-connect-ds/components/ModalQC'

  interface Props {
    isDibsyPayment: boolean
  }

  defineProps<Props>()

  const { locale } = useI18n()
  const isTermsPopupShown = ref(false)
</script>

<template>
  <div class="quote__acceptance text-medium">
    {{ $t('qic_quote_payment_acceptance_text') }}
    <LinkQC
      is-button
      data-test="quote-payment-acceptance-link"
      @click.prevent="isTermsPopupShown = true"
    >
      {{ $t('qic_quote_payment_acceptance_link') }}
    </LinkQC>
    <div>{{ $t('qic_quote_payment_acceptance_text_2') }}</div>
  </div>

  <!-- @vue-ignore -->
  <ModalQC
    v-if="isTermsPopupShown"
    :title="$t('qic_payment_terms_title')"
    :locale="locale"
    @close="isTermsPopupShown = false"
  >
    <template #content>
      <span class="text-medium">
        {{
          isDibsyPayment
            ? $t('qic_payment_terms_conditions_dibsy')
            : $t('qic_payment_terms_conditions')
        }}
      </span>
    </template>
  </ModalQC>
</template>
